<script setup lang="js">

import {ref} from "vue";
const  zsta = ref("https://cos5.51tgqj.com/techming/img/zsta@2x.png");
const props=defineProps({title:String})
</script>

<template>
  <div class="text-white text-3xl md:text-3xl lg:text-[1.8rem]  flex items-center">
    {{title}}
    <el-image :src="zsta" class="lg:h-3 lg:w-36 md:h-1 md:w-16 lg:ml-7 md:ml-3"/>
  </div>
</template>

<style scoped>

</style>
